import React from "react";
import { Box } from "@mui/material";
import Flx from "../layout/Flx";
import Txt from "../typography/Txt";
import { APP_TOKENS } from "./publicFormTokens";

/**
 * A titled section within a public-form step.
 *
 * Sections are separated by a rule rather than each being its own card — the
 * whole step reads as one sheet. Spacing and the divider come from
 * `:not(:first-of-type)` rather than a `first` prop, so a section that's
 * conditionally absent (e.g. Existing Loan on a purchase) can't leave a stray
 * leading rule behind. That relies on sections being sibling <section> elements,
 * which is why the step wrappers stack them with no gap.
 */
const PublicFormSection = ({ title, description, endContent, children, sx }) => (
  <Box
    component="section"
    sx={{
      "&:not(:first-of-type)": {
        mt: 5.5,
        pt: 4.5,
        borderTop: `1px solid ${APP_TOKENS.border}`,
      },
      ...sx,
    }}
  >
    {(title || endContent) && (
      <Flx between centerY gap={2} sx={{ mb: 3 }}>
        {/* Txt is an inline span by default, so vertical margins are ignored —
            stack with Flx column + gap instead of relying on block flow. */}
        <Flx column gap={0.5}>
          {title && (
            <Txt
              component="h2"
              sx={{
                m: 0,
                fontSize: 16,
                fontWeight: 700,
                letterSpacing: "-0.01em",
                color: APP_TOKENS.ink,
              }}
            >
              {title}
            </Txt>
          )}
          {description && (
            <Txt
              component="div"
              sx={{ fontSize: 13, color: APP_TOKENS.inkMuted }}
            >
              {description}
            </Txt>
          )}
        </Flx>
        {endContent}
      </Flx>
    )}
    {children}
  </Box>
);

export default PublicFormSection;
